import styled from 'styled-components';

export const StyledProgressCard = styled.div`
  > h3 {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    position: absolute;
    top: 16px;
    left: 17px;
  }
`;
